import { render } from "./buyFreeCourse.vue?vue&type=template&id=c687eaac&scoped=true"
import script from "./buyFreeCourse.vue?vue&type=script&lang=js"
export * from "./buyFreeCourse.vue?vue&type=script&lang=js"

import "./buyFreeCourse.vue?vue&type=style&index=0&id=c687eaac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c687eaac"]])

export default __exports__